import React from "react";
import { SunIcon, MoonIcon } from "@heroicons/react/outline";
import { useTheme } from "../contexts/ThemeContext";
import type { GameLocale } from "../i18n/types";
import { getMessages } from "../i18n/messages";

type Props = { locale: GameLocale };

export const ThemeToggle: React.FC<Props> = ({ locale }) => {
  const { theme, toggleTheme } = useTheme();
  const m = getMessages(locale);

  return (
    <button
      onClick={toggleTheme}
      className="header-icon-btn"
      aria-label={theme === "light" ? m.themeLightAria : m.themeDarkAria}
    >
      {theme === "light" ? (
        <MoonIcon className="h-6 w-6" />
      ) : (
        <SunIcon className="h-6 w-6" />
      )}
    </button>
  );
};
